export interface IResponse<D, E = null> {
  [x: string]: any;
  code: IResponseCode;
  message: string;
  data: D;
}

export enum IResponseCode {
  SUCCESS = 'SUCCESS',
  FAIL = 'FAIL',
  COMPLETED = 'COMPLETED',
  EXPIRED_TOKEN = 'EXPIRED_TOKEN',
  NULL = 'NULL',
}

export interface IApp {
  error: any;
  errorInfo: any;
  eventId: any;
}

export interface IPrecallCreds {
  apiKey: string;
  sessionId: string;
  token: string;
}
